import React, {Fragment} from "react"

const LineBreakToBr = (props) => props.source.split('\n').map((line,i)=><Fragment key={i}>{i>0?<br/>:''}{line}</Fragment>)

export default LineBreakToBr;